import { httpService } from "utils";
import { DateObject } from "utils/DateObject";

import { IEReservationQueue } from "../types/IEReservationQueue";
import { IEReservationQueueDto } from "../Dtos/IEReservationQueueDto";

export const getQueue = (
  queueId: string,
  friendlyUrl: string
): Promise<IEReservationQueue> => {
  return httpService()
    .get<IEReservationQueueDto>(
      `/e-reservation/${friendlyUrl}/queue/${queueId}`
    )
    .then((queue) => {
      return {
        ...queue,
        firstAvailableIntervalDate:
          queue.firstAvailableIntervalDate &&
          queue.firstAvailableIntervalDate !== ""
            ? DateObject(queue.firstAvailableIntervalDate)
            : undefined,
      };
    });
};
